import React ,{useState,useEffect} from 'react'
import Navbar from './Navbar'
import Carosuel from './Carosuel'
import Videos from './Videos'
import Footer from './Footer'
import './Loader.css'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'


const Home = () => {

  const urlParams = new URLSearchParams(window.location.search);
  // const msisdn = urlParams.get("msisdn");
const [number ,setNumber]=useState('')
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const navigate=useNavigate()

  // const number = Cookies.get('fitofyy_user');

  
// http://consent.hutch.lk/register-service/VA%3D%3DCQ%3D%3Ddw%3D%3D

const msisdn=Cookies.get('fitofyy_user')
console.log("MSISDN IN COOKIES",msisdn)

const checkUser = async () => {

  let formattedMsisdn = msisdn;

 
  if (typeof formattedMsisdn !== 'string') {
    formattedMsisdn = String(formattedMsisdn);
  }

  if (formattedMsisdn.substring(0, 2) !== '94') {
    if (formattedMsisdn[0] === '0') {
      formattedMsisdn = formattedMsisdn.slice(1);
    }
    formattedMsisdn = '94' + formattedMsisdn;
  }

  console.log(formattedMsisdn, "Formatted Number");
  console.log(formattedMsisdn, "Number-------------------");

  try {
    const res = await axios.get('/loginuser', {
      params: {
        msisdn: formattedMsisdn,
        service: "Fitofyy"
      }
    });

    console.log("RESPONSE",res.data)
    // If the status is 0 or 3, remove the cookie, warn the user, and navigate away.
    if (res.data.status == 0 || res.data.status==3) {
      Cookies.remove('fitofyy_user');
      // toast.warn("Subscription Expired!!");
      setTimeout(() => {
        navigate('/');
      }, 2000);
    }
    // For all other statuses, do nothing (stay on the page).
    setNumber('');
  } catch (err) {
    console.log(err);
  }
};
    
      // useEffect(() => {
      //   checkUser()
      // }, [])

    
      useEffect(() => {
        axios.get('/getheaders')
        .then(response => {
          const data = response.data;
          console.log("RESPONSE Data", data)
          if (data.status == '1') {
            Cookies.set('fitofyy_user', data.msisdn, { expires: 1 });
            Cookies.set('status', data.status, { expires: 1 });
          }
          else if(data.status=='0'){
            Cookies.set('status','0', { expires: 1 });
          }
          else{
            Cookies.set('status','0', { expires: 1 });
          }
        })
        .catch(error => console.error("Error fetching data:", error));
    }, []);

  return (
    <div className='bg-black'>
           <Navbar />
            <Carosuel />
            <Videos />
            <Footer />
    </div>  
  )
}

export default Home
